import { Injectable } from '@angular/core';
import { LeadRequestModel, RequestModel } from "./request.model";
import { ApiRoutes } from "../../../services/apiroutes";
import { HttpClient } from "@angular/common/http";
import { BackendListModel } from "../../../models/common/list.model";

@Injectable({
  providedIn: 'root'
})
export class LeadRequestService {

  constructor(private http: HttpClient) {
  }

  saveLeadRequest(leadRequest: LeadRequestModel) {
    const url = `${ApiRoutes.LeadRequest}web-request/leads/`;

    return this.http.post<LeadRequestModel>(url, leadRequest);
  }
}
